// extracted by mini-css-extract-plugin
export default {"PostCreate":"qx_a bii_qt bii_a bii_w bii_ea"};